<template>
    <Fragment>
        <form action="">
            <div class="info_title form_block_title mt_md">
                <b>Вопрос о товаре</b>
            </div>
            <div class="info_body">

                <div v-if="ok" class="alert alert-success" role="alert">
                    Сообщение отправлено!
                </div>

                <div class="form-group">
                    <label for="fb_01_01">Сформулируйте вопрос</label>
                    <textarea
                        class="form-control"
                        id="fb_01_01"
                        rows="5"
                        v-model="text"
                        @change.o="resetErrors"
                        :class="{ 'is-invalid': errors.text }"
                    ></textarea>
                </div>

                <div class="form-group mt_sm">
                    <label for="fb_01_2">Электронная почта</label>
                    <input
                        type="email"
                        class="form-control"
                        id="fb_01_2"
                        v-model="email"
                        @change.o="resetErrors"
                        :class="{ 'is-invalid': errors.email }"
                    />
                    <small id="" class="text-muted"
                        >Куда отправить ответ на вопрос, например,
                        director@valentina.ru</small
                    >
                </div>

                <div class="form-group mt_sm">
                    <div class="form-check">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            id="fb_01_3"
                            v-model="agree"
                            @change.o="resetErrors"
                            :class="{ 'is-invalid': errors.agree }"
                        />
                        <label class="form-check-label" for="fb_01_3"
                            >Даю согласие на обработку персональных
                            данных</label
                        >
                    </div>
                </div>

                <button 
                    type="button" 
                    class="btn btn_lg btn_common mt_xxs"
                    @click.prevent="send">
                    Отправить
                </button>
            </div>
        </form>
    </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

export default {
    props: ["id", "email"],

    components: { Fragment },

    data: function () {
        return {
            item: null,
            text: null,
            agree: false,
            errors: {},
        };
    },

    computed: {
        ok() {
            return this.$store.state.question.ok;
        },
    },

    methods: {
        send: function () {
            this.errors = {};

            let error = false;

            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!this.email.length || !re.test(this.email)) {
                this.errors.email = 1;
                error = true;
            }

            if (!this.text.length) {
                this.errors.text = 1;
                error = true;
            }

            if (!this.agree) {
                this.errors.agree = 1;
                error = true;
            }

            if (error) return;

            let params = {
                email: this.email,
                text: this.text,
                agree: this.agree,
                id: this.id,
            };

            this.$store.dispatch("question/addQuestion", params);
        },

        resetErrors: function (e) {
            this.errors = {};
        },
    },
};
</script>
